import { render, staticRenderFns } from "./BoostSalesOfCoinsBanner.vue?vue&type=template&id=51d77d19&scoped=true&"
import script from "./BoostSalesOfCoinsBanner.vue?vue&type=script&lang=ts&"
export * from "./BoostSalesOfCoinsBanner.vue?vue&type=script&lang=ts&"
import style0 from "./BoostSalesOfCoinsBanner.vue?vue&type=style&index=0&id=51d77d19&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d77d19",
  null
  
)

export default component.exports